import { useMutation } from 'react-query'
import postRegisterResponsible from '../services/postRegisterResponsible'

function usePostRegisterResponsible() {

  return useMutation((value:object)=>postRegisterResponsible(value) );
}

export default usePostRegisterResponsible
